import ReactGA from 'react-ga4';

import { CssBaseline, StyledEngineProvider } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

// routing
import Routes from 'routes';

// defaultTheme
import themeConfig from 'configs/themeConfig';
import theme from 'themes';
import customization from 'themes/customize';

// project imports
import { LocalizationProvider } from '@mui/x-date-pickers';
import 'dayjs/locale/zh-tw';
import NavigationScroll from 'layouts/NavigationScroll';

import { ENV_TYPES } from 'configs/constant';
import configs from 'configs/envConfig';

// ==============================|| APP ||============================== //
if (configs.GA_TRACKER_ID)
    ReactGA.initialize(configs.GA_TRACKER_ID, {
        debug: configs.STAGE !== ENV_TYPES.PROD,
        titleCase: false
    });

const App = () => {
    const { defaultIsDarkMode, defaultIsRTL, ...options } = themeConfig || {};
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={theme(customization, defaultIsDarkMode, defaultIsRTL, options)}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'zh-tw'}>
                    <CssBaseline />
                    <NavigationScroll>
                        <Routes />
                    </NavigationScroll>
                </LocalizationProvider>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;
